export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11317.9937b3e3.jpg";